export function installRuntimeEnhancements() {
  if (typeof window === 'undefined') return;
  const state = window as Window & { __convertxRefreshActualsUntil?: number; __convertxInstalled?: boolean };
  if (state.__convertxInstalled) return;
  state.__convertxInstalled = true;

  const markRefreshIntent = () => { state.__convertxRefreshActualsUntil = Date.now() + 15000; };

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('button') : null;
    const text = button?.textContent?.toLowerCase().replace(/\s+/g, ' ') ?? '';
    if (/benchmark|refresh|sync|update/.test(text)) markRefreshIntent();
  }, true);

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    try {
      const method = init?.method ?? (input instanceof Request ? input.method : 'GET');
      const rawUrl = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
      const url = new URL(rawUrl, window.location.origin);
      const shouldRefresh = Date.now() < Number(state.__convertxRefreshActualsUntil || 0);
      if (method.toUpperCase() === 'GET' && url.pathname === '/api/conversion-x/actuals' && shouldRefresh) {
        url.searchParams.set('refresh', '1');
        return originalFetch(url.toString(), init);
      }
    } catch {
      return originalFetch(input, init);
    }
    return originalFetch(input, init);
  };
}
